<ng-container>
    <h1 mat-dialog-title
        class="draggable-dialogue-header title-h"
        cdkDrag
        cdkDragRootElement=".cdk-overlay-pane"
        cdkDragHandle>
        Schedule a {{this.StructureTypeName}} Event
    </h1>

    <p>This dialog is under construction.</p>

    <div class="trigger-buttons-div">
        <button mat-flat-button
                type="submit"
                color="primary"
                class="theme-primary-btn"
                [disabled]="this.SaveDisabled"
                (click)="this.save()">
            Save
        </button>

        <button mat-flat-button
                class="basic"
                style="margin-left: 10px;"
                (click)="this.cancel()">
            Cancel
        </button>
    </div>

</ng-container>
